const ITEMS = [
  "Native Arabic tutors",
  "Wembley Park HA9 0FJ",
  "Levantine — flagship dialect",
  "Modern Standard Arabic",
  "Gulf Arabic",
  "Egyptian dialect",
  "90–120 minute lessons",
  "Flexible schedule — any time",
];

export const Marquee = () => (
  <section aria-hidden="true" className="overflow-hidden border-y border-pine bg-pine py-4">
    <div className="flex w-max animate-marquee gap-10">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span
          key={i}
          className="flex items-center gap-10 whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.3em] text-paper/90"
        >
          {item}
          <span className="text-gold">✦</span>
        </span>
      ))}
    </div>
  </section>
);

export default Marquee;
